// Contact.jsx
import React, { useRef, useState } from 'react';
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import emailjs from '@emailjs/browser';
import { 
  FaFacebookF, 
  FaInstagram, 
  FaTiktok, 
  FaClock, 
  FaPhone, 
  FaMapMarkerAlt, 
  FaPaperPlane, 
  FaExclamationTriangle 
} from 'react-icons/fa';
import { Helmet } from 'react-helmet';
import "./Contact.css";

const Contact = () => {
  // Structured Data (Păstrat intact conform cerinței SEO)
  const businessStructuredData = {
    "@context": "https://schema.org",
    "@type": "AutoRepair",
    "name": "ITP Sector 2",
    "url": "https://itp-sector2.ro",
    "logo": "https://itp-sector2.ro/logo.png",
    "image": "https://itp-sector2.ro/images/itp-sector2.jpg",
    "description": "Servicii ITP auto în București Sector 2. Program complet, servicii rapide și profesionale.",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Șoseaua Electronicii 26",
      "addressLocality": "București",
      "addressRegion": "Sector 2",
      "postalCode": "021652",
      "addressCountry": "RO"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "44.451639500426595",
      "longitude": "26.133095075701938"
    },
    "telephone": "+40726104358",
    "openingHours": [
      "Mo 09:00-19:30",
      "Tu 09:00-19:30", 
      "We 09:00-19:30",
      "Th 09:00-19:30",
      "Fr 09:00-19:30",
      "Sa 08:00-13:30"
    ],
    "priceRange": "$$",
    "currenciesAccepted": "RON",
    "paymentAccepted": ["Cash", "Credit Card"],
    "areaServed": {
      "@type": "Place",
      "name": "București Sector 2"
    }
  };

  const form = useRef();
  const [status, setStatus] = useState('');
  const [statusType, setStatusType] = useState(''); // 'success' sau 'error'

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_ije7bdn', 'template_l1jp2wc', form.current, 'r0TmJS0QkhYbtIT-1')
      .then(() => {
        setStatus('Mesaj trimis cu succes! Echipa noastră vă va contacta în cel mai scurt timp.');
        setStatusType('success');
        form.current.reset();
      }, () => {
        setStatus('Eroare la trimiterea mesajului. Vă rugăm să încercați din nou sau să ne sunați.');
        setStatusType('error');
      });
  };

  const schedule = [
    { day: 'Luni', hours: '09:00 - 19:30', isOpen: true },
    { day: 'Marți', hours: '09:00 - 19:30', isOpen: true },
    { day: 'Miercuri', hours: '09:00 - 19:30', isOpen: true },
    { day: 'Joi', hours: '09:00 - 19:30', isOpen: true },
    { day: 'Vineri', hours: '09:00 - 19:30', isOpen: true },
    { day: 'Sâmbătă', hours: '08:00 - 13:30', isOpen: true },
    { day: 'Duminică', hours: 'Închis', isOpen: false }
  ];

  const currentDay = ['Duminică', 'Luni', 'Marți', 'Miercuri', 'Joi', 'Vineri', 'Sâmbătă'][new Date().getDay()];

  return (
    <>
      <Helmet>
        <title>Contact ITP Sector 2 | Program Orar | București</title>
        <meta name="description" content="Contactează ITP Sector 2 București. Program: Luni-Vineri 09:00-19:30, Sâmbătă 08:00-13:30. Telefon: +40726104358. Șoseaua Electricității 26." />
        <link rel="canonical" href="https://itp-sector2.ro/contact" />
      </Helmet>
      
      <script 
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(businessStructuredData) }}
      />

      <Navbar/>

      <main className="premium-contact-page">
        {/* Hero Section cu Breadcrumbs integrat discret */}
        <section className="contact-hero">
          <div className="hero-bg-overlay"></div>
          <div className="hero-container">
            <h1 className="hero-title">CONTACT</h1>
          </div>
        </section>

        {/* Secțiunea Principală de Conținut */}
        <section className="contact-content-grid">
          <div className="premium-container">
            
            {/* Quick Action: Call Banner */}
            <div className="premium-cta-card">
              <div className="cta-info">
                <h2>Ai întrebări sau vrei o programare rapidă?</h2>
                <p>Echipa noastră este pregătită să îți răspundă la orice detaliu tehnic.</p>
              </div>
              <a href="tel:+40726104358" className="premium-phone-btn" aria-label="Sună acum">
                <FaPhone className="btn-icon-pulse" /> Suna Acum
              </a>
            </div>

            {/* Info & Form Wrapper */}
            <div className="main-info-flex">
              
              {/* Partea Stângă: Carduri Informative */}
              <div className="info-cards-column">
                
                {/* Card Program */}
                <div className="premium-card">
                  <div className="p-card-header">
                    <FaClock className="p-card-icon" />
                    <h3>PROGRAM DE LUCRU</h3>
                  </div>
                  <div className="p-schedule-list">
                    {schedule.map((item, index) => (
                      <div 
                        key={index} 
                        className={`p-schedule-row ${item.day === currentDay ? 'p-current-day' : ''} ${!item.isOpen ? 'p-closed-day' : ''}`}
                      >
                        <span className="p-day">{item.day}</span>
                        <span className="p-hours">{item.hours}</span>
                      </div>
                    ))}
                  </div>
                  <p className="p-note">* Orarul poate varia în zilele de sărbătoare legală.</p>
                </div>

                {/* Card Date de Contact */}
                <div className="premium-card">
                  <div className="p-card-header">
                    <FaMapMarkerAlt className="p-card-icon" />
                    <h3>DATE CONFIGURARE</h3>
                  </div>
                  <div className="p-details-list">
                    <div className="p-details-item">
                      <span className="p-label">TELEFON REZERVĂRI</span>
                      <a href="tel:+40726104358" className="p-value-link">+40 726 104 358</a>
                    </div>
                    <div className="p-details-item">
                      <span className="p-label">LOCAȚIE STAȚIE</span>
                      <p className="p-value">Șoseaua Electronicii 24, București, Sector 2</p>
                    </div>
                  </div>
                </div>

              </div>

              {/* Partea Dreaptă: Formularul Premium */}
              <div className="form-column">
                <div className="premium-card form-card">
                  <h3>TRIMITE UN MESAJ</h3>
                  <p className="form-desc">Completează formularul de mai jos, iar un specialist ITP te va contacta.</p>
                  
                  <form ref={form} onSubmit={sendEmail} className="p-form">
                    <div className="p-input-group">
                      <input type="text" name="user_name" required placeholder=" " id="user_name" />
                      <label htmlFor="user_name">Nume complet *</label>
                    </div>

                    <div className="p-input-group">
                      <input type="email" name="user_email" required placeholder=" " id="user_email" />
                      <label htmlFor="user_email">Adresă Email *</label>
                    </div>

                    <div className="p-input-group">
                      <input type="tel" name="user_phone" required placeholder=" " id="user_phone" />
                      <label htmlFor="user_phone">Număr de telefon *</label>
                    </div>

                    <div className="p-input-group">
                      <textarea name="message" rows="4" placeholder=" " id="message"></textarea>
                      <label htmlFor="message">Mesajul tău (Opțional)</label>
                    </div>

                    {status && (
                      <div className={`p-status-box ${statusType}`}>
                        {statusType === 'success' ? <FaPaperPlane /> : <FaExclamationTriangle />}
                        <span>{status}</span>
                      </div>
                    )}

                    <button type="submit" className="p-submit-btn">
                      TRIMITE SOLICITAREA
                    </button>
                  </form>

                  {/* Social links integrate organic la baza formularului */}
                  <div className="p-social-wrapper">
                    <span>CONECTEAZĂ-TE CU NOI:</span>
                    <div className="p-social-links">
                      <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FaFacebookF /></a>
                      <a href="https://www.instagram.com/itp_auto_moto" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram /></a>
                      <a href="https://www.tiktok.com" target="_blank" rel="noopener noreferrer" aria-label="TikTok"><FaTiktok /></a>
                    </div>
                  </div>

                </div>
              </div>

            </div>

          </div>
        </section>

        {/* Hartă Full-Width integrată curat în designul industrial */}
        <section className="p-map-section">
          <div className="p-map-overlay-title">LOCALIZARE STAȚIE</div>
          <div className="p-iframe-wrapper">
            <iframe
              title="Google Maps - Soseaua Electronicii nr 26"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5696.19816253118!2d26.133095075701938!3d44.451639500426595!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40b1f8dabbee74f3%3A0xa826c470671cd2d8!2s%C8%98oseaua%20Electronicii%2026%2C%20Bucure%C8%99ti!5e0!3m2!1sen!2sro!4v1753171367049!5m2!1sen!2sro"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </section>
      </main>
      <Footer/>
    </>
  );
};

export default Contact;